import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {I18NextTitle} from 'angular-i18next';
import {AuthService} from 'app/core/services/auth.service';
import {FormService} from 'app/core/services/form.service';
import {AppUrls} from 'app/core/url/app-urls.service';
import {NavigateAfterLoginService} from 'app/features/sign-in/services/navigate-after-login.service';
import {SignInWithGoogleService} from 'app/features/sign-up/services/sign-in-with-google.service';
import {DomService} from 'app/core/services/dom.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'sign-in-page',
    templateUrl: './sign-in-page.component.html',
    styleUrls: ['../../sign-up/sign-up-form/sign-up-form.component.scss', './sign-in-page.component.scss'],
    providers: [FormService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInPageComponent implements OnInit, OnDestroy {
    form: FormGroup;
    appUrls = AppUrls;
    signInWithGoogleUrl = this.signInWithGoogle.getOAuthUrl();

    errorMessage: string;

    sub: Subscription = Subscription.EMPTY;

    get twoFaEmailForm$() {
        return this.auth.twoFaEmailCode$;
    }

    get twoFaOtpForm$() {
        return this.auth.twoFaOneTimePassword$;
    }

    constructor(
        private fb: FormBuilder,
        private auth: AuthService,
        private title: I18NextTitle,
        private afterLogin: NavigateAfterLoginService,
        public formService: FormService,
        public dom: DomService,
        public signInWithGoogle: SignInWithGoogleService
    ) {}

    ngOnInit() {
        this.title.setTitle('signin.page_title');
        this.form = this.fb.group({
            email: ['', [this.formService.trimValidatorFn]],
            password: [''],
            twoFactorEmailCode: [''],
            twoFactorOneTimePassword: [''],
        });
        this.formService.init(this.form);
        this.sub = this.formService.errorMessages$.subscribe(msg => (this.errorMessage = msg));
    }

    onSubmit(event: Event) {
        event.preventDefault();
        this.formService.submit(this.auth.signIn2Fa(this.form.value)).subscribe(
            user => this.afterLogin.navigate(user),
            err => this.formService.catchError(err)
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
